import { createContext, useMemo } from 'react';
import TableStore from './TableStore';

export const TableStoreContext = createContext<TableStore>({} as TableStore);

export const TableStoreProvider: React.FC<{}> = ({ children }) => {
  const tableStore = useMemo(() => new TableStore(), []);
  return (
    <TableStoreContext.Provider value={tableStore}>
      {children}
    </TableStoreContext.Provider>
  );
};
